<template>
  <div class="adminaside" width="258px">
    <div class="fixed">
      <router-link to="/project" class="alogo"></router-link>
      <el-aside width="258px">
        <el-menu default-active="1" class="eldemo" @open="handleOpen" @close="handleClose" :router="true" :default-openeds="openeds">
          <el-menu-item index="/home" v-show="MenuInclude('1')">
            <span slot="title">首页</span>
          </el-menu-item>
          <el-submenu index="1" v-show="MenuInclude('2')">
            <template slot="title">
              <i class="sideicon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <rect x="2" y="7" width="20" height="14" rx="2" />
                  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                </svg>
              </i>
              <span slot="title">客户项目</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/project" v-show="MenuInclude('3')"><span>项目列表</span></el-menu-item>
              <el-menu-item index="/apply" v-show="MenuInclude('4')"><span>收款管理</span></el-menu-item>
              <el-menu-item index="/invoice" v-show="MenuInclude('5')"><span>发票管理</span></el-menu-item>
              <el-menu-item index="/purchase" v-show="MenuInclude('6')"><span>供应商合同管理</span></el-menu-item>
              <el-menu-item index="/pay" v-show="MenuInclude('7')"><span>支付管理</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2" v-show="MenuInclude('8')">
            <template slot="title">
              <i class="sideicon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <circle cx="9" cy="21" r="1" />
                  <circle cx="20" cy="21" r="1" />
                  <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                </svg>
              </i>
              <span slot="title">行政采购</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/admin" v-show="MenuInclude('9')"><span>项目列表</span></el-menu-item>
              <el-menu-item index="/adPurchase" v-show="MenuInclude('10')"><span>供应商合同管理</span></el-menu-item>
              <el-menu-item index="/adPay" v-show="MenuInclude('11')"><span>支付管理</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="3" v-show="MenuInclude('12')">
            <template slot="title">
              <i class="sideicon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </i>
              <span slot="title">人力资源</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/human" v-show="MenuInclude('13')"><span>项目列表</span></el-menu-item>
              <el-menu-item index="/hrPurchase" v-show="MenuInclude('14')"><span>供应商合同管理</span></el-menu-item>
              <el-menu-item index="/hrPay" v-show="MenuInclude('15')"><span>支付管理</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="4" v-show="MenuInclude('16')">
            <template slot="title">
              <i class="sideicon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                  <polyline points="16 11 18 13 22 9" />
                </svg>
              </i>
              <span slot="title">个人事务管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/expense" v-show="MenuInclude('17')"><span>报销管理</span></el-menu-item>
              <el-menu-item index="/vacation"><span>休假管理</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="5" v-show="MenuInclude('19')">
            <template slot="title">
              <i class="sideicon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M3 21h18" />
                  <path d="M5 21V7l7-4 7 4v14" />
                  <path d="M9 9h.01M9 13h.01M9 17h.01M15 9h.01M15 13h.01M15 17h.01" />
                </svg>
              </i>
              <span slot="title">客户/供应商管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/client" v-show="MenuInclude('20')"><span>客户管理</span></el-menu-item>
              <el-menu-item index="/vendor" v-show="MenuInclude('21')"><span>供应商管理</span></el-menu-item>
              <el-menu-item index="/pubcase" v-show="MenuInclude('414')"><span>供应商刊例</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="8" v-show="MenuInclude('403')">
            <template slot="title">
              <i class="sideicon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                  <line x1="12" y1="22.08" x2="12" y2="12" />
                </svg>
              </i>
              <span slot="title">物品管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/asset" v-show="MenuInclude('403')"><span>物品管理</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="6" v-show="MenuInclude('22')">
            <template slot="title">
              <div class="onetitle">
                <i class="sideicon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </i>
                <span>账号管理</span>
              </div>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/author" v-show="MenuInclude('23')"><span>账号管理</span></el-menu-item>
              <el-menu-item index="/role" v-show="MenuInclude('24')"><span>职位管理</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="7" v-show="MenuInclude('25')">
            <template slot="title">
              <i class="sideicon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <circle cx="12" cy="12" r="1" />
                  <circle cx="12" cy="5" r="1" />
                  <circle cx="12" cy="19" r="1" />
                </svg>
              </i>
              <span slot="title">其他管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index="/adminLog" v-show="MenuInclude('26')"><span>后台管理日志</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
    </div>
  </div>
</template>

<script>
import * as api from '@/api'
import store from '../store'

export default {
  name: 'adminaside',
  data() {
    return {
      menuLimtList: [],
      user: JSON.parse(localStorage.getItem('setUserInfo')) || {},
      bkUserArr: {},
      permissionList: [],
      lv: '',
      user_id: '',
      openeds: ['1', '2', '3', '4', '5', '8'],
      scrollTop: '',
    }
  },
  mounted() {
    this.getDetail(this.user.id)
  },
  computed: {
    _p() {
      return (id) => {
        return this.permissionList.includes(id) || this.lv == true
      }
    },
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath)
    },
    p(id) {
      return this.permissionList.includes(id) || this.lv == true
    },
    getDetail(id) {
      api
        .getAccountDetail({
          uid: id,
        })
        .then((res) => {
          this.lv = res.bkUserArr.level
          this.user_id = res.bkUserArr.id
          this.menuLimtList = res.bkUserArr.role.menu_ids.split(',')
          store.commit('setLevel', this.lv)
          store.commit('setName', res.bkUserArr.realname)
          store.commit('setUserId', res.bkUserArr.id)
          store.commit('setMineHolidyData', res.bkUserArr.holiday)
          store.commit('setMenuLimtList', res.bkUserArr.role.menu_ids.split(','))
          if (res.bkUserArr.permissionList) {
            const permissionList = res.bkUserArr.permissionList || []
            this.permissionList = permissionList.map((item) => item.menu_id)
          }
          return res
        })
    },
    MenuInclude(val) {
      return this.menuLimtList.includes(val)
    },
  },
}
</script>

<style lang="scss">
/* ============================================
   0825修改：侧边栏图标改为内联 SVG（线条图标，stroke=currentColor 跟随父级文字色）
   每个菜单项按文字含义使用差异化图标，不再共用一个 list.png
   ============================================ */
.sideicon {
  width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  opacity: 0.65;
  color: #fff; /* 父级菜单是白字，currentColor 跟随 */
  transition: opacity 0.2s ease;
  vertical-align: middle;
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
    display: block;
  }
}

/* 0825新增：账号管理这一项的子模板用了 div.onetitle 包裹图标+文字，
   需要 flex 居中对齐，避免图标下沉或文字错位 */
.onetitle {
  display: flex;
  align-items: center;
  line-height: 1;
}

/* ============================================
   滚动条：侧边栏深色底 → 白色滚动条
   全局 * 规则用深色 thumb，此处用更高优先级 + !important 覆盖
   ============================================ */
.el-aside {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.18) transparent;
  scroll-behavior: smooth;
}
.el-aside::-webkit-scrollbar {
  width: 4px !important;
  height: 4px !important;
  display: block;
}
.el-aside::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.18) !important;
  border-radius: 2px !important;
  transition: background 0.2s ease !important;
}
.el-aside::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.32) !important;
}
.el-aside::-webkit-scrollbar-track {
  background: transparent !important;
}


.adminaside {
  width: 258px;
  height: 100vh;
  position: relative;
  padding-top: 28px;
  background: #0E0F22;
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC',
    'Microsoft YaHei', 'Segoe UI', Roboto, sans-serif;

  .fixed {
    width: 258px;
    position: fixed;

    .alogo {
      width: 124px;
      height: 18px;
      display: block;
      margin: 0 auto 32px;
      background: url(../assets/alogo.png) no-repeat;
      background-size: contain;
      transition: opacity 0.2s ease;
      opacity: 0.95;
    }
    .alogo:hover {
      opacity: 0.7;
    }

    .el-aside {
      width: 258px;
      height: calc(100vh - 96px);
      overflow-y: scroll;
    }

    /* ============================================
       一级菜单（父级）· el-submenu 标题 + 独立首页
       WorkBuddy 风格：粗体、字号紧凑、无边框、扁平
       ============================================ */
    .el-submenu__title,
    .eldemo > .el-menu-item {
      font-size: 14px !important;
      font-weight: 500 !important;
      color: #fff !important;
      background: transparent !important;
      border: none !important;
      box-shadow: none !important;
      padding: 12px 20px !important;
      margin: 0 !important;
      border-radius: 0 !important;
      letter-spacing: 0.3px;
      height: auto !important;
      min-height: 0 !important;
      line-height: 1.3 !important;
      transition: background 0.2s ease, color 0.2s ease;

      .sideicon {
        opacity: 0.65;
        transition: opacity 0.2s ease;
      }

      .el-submenu__icon-arrow {
        color: rgba(255, 255, 255, 0.5);
        font-size: 13px;
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
          color 0.2s ease;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.04) !important;
        color: #fff !important;

        .sideicon {
          opacity: 1;
        }

        .el-submenu__icon-arrow {
          color: rgba(255, 255, 255, 0.85);
        }
      }
    }

    /* 父级展开后保持粗体 + 箭头旋转 */
    .el-submenu.is-opened > .el-submenu__title {
      .sideicon {
        opacity: 1;
      }

      .el-submenu__icon-arrow {
        color: #fff;
        transform: rotate(180deg);
      }
    }

    /* ============================================
       二级菜单（子级）
       WorkBuddy 风格：缩进大、字号更小、颜色更淡、扁平
       ============================================ */
    .el-menu {
      border-right: none;
      background: transparent;

      .el-menu-item-group__title {
        padding: 0;
      }

      .el-menu-item {
        font-size: 13px !important;
        font-weight: 400 !important;
        color: rgba(255, 255, 255, 0.62) !important;
        background: transparent !important;
        border: none !important;
        box-shadow: none !important;
        padding: 8px 20px 8px 44px !important;
        margin: 0 !important;
        border-radius: 0 !important;
        letter-spacing: 0.2px;
        height: auto !important;
        min-height: 0 !important;
        line-height: 1.5 !important;
        transition: background 0.2s ease, color 0.2s ease;

        span {
          font-size: 13px;
        }

        &:hover {
          background: rgba(255, 255, 255, 0.04) !important;
          color: rgba(255, 255, 255, 0.92) !important;
        }

        &.is-active {
          background: rgba(135, 136, 193, 0.18) !important; /* --accent 紫色 tint */
          color: #fff !important;
          font-weight: 500 !important;

          span {
            border-bottom: none !important;
          }
        }
      }
    }

    /* ============================================
       节间距：每个一级菜单之间留 4px 呼吸
       ============================================ */
    .eldemo > * + * {
      margin-top: 4px !important;
    }

    /* ============================================
       子菜单展开/收起过渡（动效保留）
       ============================================ */
    .el-menu--inline {
      transition: height 0.3s cubic-bezier(0.4, 0, 0.2, 1),
        opacity 0.3s ease !important;
      overflow: hidden;
    }
  }
}
</style>
